"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const NotAllowedCircleIcon = ({
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ...otherProps,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M57.34 61.407a1.827 1.827 0 113.654.001 1.827 1.827 0 01-3.654-.001",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M54.39 65.162a33.835 33.835 0 01-18.1 5.213c-18.776 0-33.998-15.222-33.998-34 0-18.777 15.222-34 33.999-34 18.776 0 34 15.223 34 34a33.842 33.842 0 01-6.871 20.496",
        stroke: "#fefefe",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M18.468 36.243c0-9.738 7.894-17.632 17.632-17.632 9.738 0 17.632 7.894 17.632 17.632 0 9.738-7.894 17.632-17.632 17.632-9.738 0-17.632-7.894-17.632-17.632zM24.393 47.95l23.415-23.415",
        stroke: "#4caa50",
        strokeWidth: 3,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "svg-stroke-primary"
      })]
    })]
  });
};

NotAllowedCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(NotAllowedCircleIcon);

exports.default = _default;